import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3Vertical: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dot-grid-1x3-vertical, menu, drag, grab"} maskId="square-filled-radius-0-stroke-1-IconDotGrid1x3Vertical"><path d="M13.5 2H10.5V5H13.5V2Z" fill="currentColor"/><path d="M13.5 10.5H10.5V13.5H13.5V10.5Z" fill="currentColor"/><path d="M13.5 19H10.5V22H13.5V19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDotGrid1x3Vertical;
